import { Authenticated, Refine } from '@refinedev/core';
import routerProvider from '@refinedev/react-router';
import { dataProvider, liveProvider } from '@refinedev/supabase';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router';

import { authProvider } from './authProvider';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Configuracao } from './pages/Configuracao';
import { Moderacao } from './pages/Moderacao';
import { SerieDetalhe } from './pages/SerieDetalhe';
import { SerieForm } from './pages/SerieForm';
import { SeriesList } from './pages/SeriesList';
import { supabaseClient } from './supabase';

/**
 * Painel da Venove (`admin.venove.com.br`).
 *
 * O painel **não tem poder especial**: usa a mesma chave publicável do site, e quem autoriza
 * é a RLS, que pergunta `is_admin()` — ou seja, `app_metadata.role = 'admin'` no JWT (regra 3).
 * O service role nunca entra aqui; quando for preciso poder de servidor (subir vídeo,
 * reembolsar), o painel chama a Edge Function correspondente.
 *
 * O que já existe: catálogo (séries, temporadas, episódios, agendamento) e moderação. O que
 * depende de chave: envio de vídeo (Bunny) e reembolso (Mercado Pago). O que é da Etapa 3:
 * suporte, configuração remota e resumo de consumo por pagamento.
 */
export function App() {
  return (
    <BrowserRouter>
      <Refine
        dataProvider={dataProvider(supabaseClient)}
        liveProvider={liveProvider(supabaseClient)}
        authProvider={authProvider}
        routerProvider={routerProvider}
        resources={[
          { name: 'series', list: '/series', create: '/series/nova', edit: '/series/:id/editar' },
          { name: 'seasons' },
          { name: 'episodes' },
          { name: 'comments' },
          { name: 'comment_reports', list: '/moderacao' },
          { name: 'app_config', list: '/configuracao' },
        ]}
        options={{ syncWithLocation: true, warnWhenUnsavedChanges: true, disableTelemetry: true }}
      >
        <Routes>
          <Route
            element={
              <Authenticated key="painel" fallback={<Navigate to="/login" replace />}>
                <Layout>
                  <Outlet />
                </Layout>
              </Authenticated>
            }
          >
            <Route index element={<Navigate to="/series" replace />} />
            <Route path="/series" element={<SeriesList />} />
            <Route path="/series/nova" element={<SerieForm />} />
            <Route path="/series/:id" element={<SerieDetalhe />} />
            <Route path="/series/:id/editar" element={<SerieForm />} />
            <Route path="/moderacao" element={<Moderacao />} />
            <Route path="/configuracao" element={<Configuracao />} />
          </Route>

          <Route path="/login" element={<Login />} />
        </Routes>
      </Refine>
    </BrowserRouter>
  );
}
